import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const locationDetailContainer: AbgSxProps = (theme) => ({
  width: 440,
  maxHeight: '75vh',
  padding: '24px',
  backgroundColor: theme.palette.background.tertiary,
  borderRadius: 0,
  borderTopRightRadius: `${theme.borderRadius.mediumCard}px`,
  borderBottomRightRadius: `${theme.borderRadius.mediumCard}px`,
});

export const iconContainer = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,
  borderRadius: '100%',
};

export const h5 = {
  margin: 0,
  fontSize: '24px',
  lineHeight: '24px',
  color: paletteBase.black,
};

const sharedTypographySubText: AbgSxProps = (theme) => ({
  color: theme.palette.grey[600],
  margin: 0,
  fontSize: '12px',
  lineHeight: '15px',
});

export const typographyAddressSubText: AbgSxProps = (theme) => ({
  ...sharedTypographySubText(theme),
  marginTop: '3px',
  lineHeight: '24px',
});

export const typographyHoursSubText: AbgSxProps = (theme) => ({
  ...sharedTypographySubText(theme),
  marginBottom: '5px',
});

export const subHeading = {
  fontWeight: 500,
  fontSize: '14px',
  fontStyle: 'normal',
  lineHeight: 1.9,
};

export const linkContainer = {
  fontSize: '14px',
  lineHeight: '22px',
  paddingTop: '8px',
  paddingLeft: '10px',
};
